import { useContext } from "react";

import { userProfileDBContext } from "@utils/components/UserProfileContext";

const useUserProfile = () => useContext(userProfileDBContext);

export default useUserProfile;
